.mark {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 5;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  overflow: hidden;
  opacity: 0.94;
  pointer-events: none;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.45);
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.dimmed {
  opacity: 0.4;
  transform: scale(0.92);
}

@media (max-width: 640px) {
  .mark {
    width: 28px;
    height: 28px;
    top: 10px;
    left: 10px;
    border-radius: 8px;
  }

  .mark svg {
    width: 28px;
    height: 28px;
  }
}
